// extracted by mini-css-extract-plugin
export default {"link":"Link_link__BXAso","container":"Link_container__UEjHv","icon":"Link_icon__cLY2r"};